import { StipRequestTask } from '../stip-request-task/stip-request-task.model';
import { InfoRequestTask } from '../info-request-task/info-request-task.model';
import { InfoRequestCommentTask } from '../info-request-comment-task/info-request-comment-task.model';
import { ActivityTask } from '../activity-task/activity-task.model';
import { ReminderTask } from '../reminder-task/reminder-task.model';
import { WorkflowTask } from '../workflow-task/workflow-task.model';
import { Task } from './task.model';
import { LSModelFactory } from 'ng2-app/util/ls-model-factory';
import { CallActivity } from '../call-activity/call-activity.model';

interface FactoryMap {
    [type: string]: LSModelFactory<Task>;
}

export interface TaskJson {
    type: string;
}

export class TaskFactory {

    private taskFactories: FactoryMap;

    constructor() {
        this.taskFactories = {
            activity: new LSModelFactory<ActivityTask>(ActivityTask),
            reminder: new LSModelFactory<ReminderTask>(ReminderTask),
            workflow: new LSModelFactory<WorkflowTask>(WorkflowTask),
            infoRequest: new LSModelFactory<InfoRequestTask>(InfoRequestTask),
            infoRequestComment: new LSModelFactory<InfoRequestCommentTask>(InfoRequestCommentTask),
            infoRequestComplete: new LSModelFactory<InfoRequestTask>(InfoRequestTask),
            stipRequest: new LSModelFactory<StipRequestTask>(StipRequestTask),
            callActivity: new LSModelFactory<CallActivity>(CallActivity)
        };
    }

    fromJson(taskJson: TaskJson): Task {
        return this.taskFactories[taskJson.type].fromJson(taskJson);
    }

}
